import { createFileRoute } from '@tanstack/react-router';

import { RoiProjectDetailPage } from '@/features/roi-demo/components/RoiProjectDetailPage';

export const Route = createFileRoute('/roi-demo/projects/$projectId')({
  component: RoiProjectDetailRoute,
});

function RoiProjectDetailRoute() {
  const { projectId } = Route.useParams();
  return <RoiProjectDetailPage projectId={projectId} />;
}
